import React, { useMemo } from 'react';

import { useStyles } from './style';
import { Chip, Typography } from '@material-ui/core';
import { PaymentMethod } from '../../../../../api/payment-method/types';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { useSetDefaultPaymentMethodMutation } from '../../../../../api/payment-method';
import { ToastService } from '../../../../../shared/services/toastService';

interface Props {
  paymentItem: PaymentMethod;
  onPaymentDetailClick: (paymentItem: PaymentMethod) => void;
}

export const PaymentItem: React.FC<Props> = ({ paymentItem, onPaymentDetailClick }) => {
  const classes = useStyles();
  const [setDefaultPaymentMethod] = useSetDefaultPaymentMethodMutation();

  const onSetDefaultClick = () => {
    setDefaultPaymentMethod({
      payment_method: paymentItem.id,
    }).then((res) => {
      if ('data' in res && res.data?.success) {
        ToastService.success('Default payment method set successfully');
      } else {
        ToastService.error('Failed to set default payment method');
      }
    });
  };

  const onItemDetailClick = () => {
    onPaymentDetailClick(paymentItem);
  };

  const isExpiredCard = useMemo(() => {  
    const expMonth = paymentItem.exp_month;
    const expYear = paymentItem.exp_year;
    if (isNaN(expMonth) || isNaN(expYear)) return true; // invalid format = treat as expired
  
    // Set to the 1st of the next expMonth (so "4/2025" expires on May 1st)
    const expiryDate = new Date(expYear, expMonth);
    const now = new Date();
  
    return expiryDate <= now;
  }, [paymentItem]);

  return (
    <div className={classes.root}>
      <div>
        <Typography className={classes.paymentTitle}>[{paymentItem.display_brand}] {paymentItem.funding}</Typography>
        <Typography className={classes.paymentSubTitle}>***** <span className={classes.last4Text}>{paymentItem.last4}</span>
          {
            isExpiredCard
              ? <span className={classes.expiredText}>Expired {paymentItem.exp_month}/{paymentItem.exp_year}</span>
              : <span>Expiry to {paymentItem.exp_month}/{paymentItem.exp_year}</span>
          }
        </Typography>
      </div>
      <div className={classes.actionsContainer}>
        {paymentItem.default ? (
          <Chip
            label='DEFAULT'
            className={classes.defaultChip}
          />
        ) : (
          !isExpiredCard && <span className={classes.setDefaultText} onClick={onSetDefaultClick}>
            Set default
          </span>
        )}
        <div className={classes.rightIcon} onClick={onItemDetailClick}>
          <KeyboardArrowRightIcon />
        </div>
      </div>
    </div>
  );
};
